angular.module('eStories.pagination', [])
    .component('pagination', {
        transclude: true,
        bindings: {
            currentPagination: '<',
        },
        controller: 'PaginationCtrl',
        controllerAs: 'paginationCtrl',
        templateUrl: '/components/pagination/pagination.tmpl.html'
    }).controller('PaginationCtrl',
    ['$scope', function ($scope) {
        this.getNumberOfPages = () => {
            return Math.ceil(this.currentPagination.totalCount / this.currentPagination.itemsPerPage)
        };

        this.shouldShowFirstPageButton = () => {
            return this.getPageArray().indexOf(1) === -1
        };

        this.nextPage = () => {
            if (this.currentPagination.pageNumber === this.getNumberOfPages()) return;
            this.gotoPage(this.currentPagination.pageNumber + 1)
        };

        this.previousPage = () => {
            if (this.currentPagination.pageNumber === 1) return;
            this.gotoPage(this.currentPagination.pageNumber - 1);
        };

        this.gotoPage = (pageNumber) => {
            if (pageNumber === this.currentPagination.pageNumber) return;
            $scope.$emit('getPage', pageNumber);
        };

        this.shouldShowLastPageButton = () => {
            const lastPage = this.getNumberOfPages();
            return this.getPageArray().indexOf(lastPage) === -1
        };

        this.loadMore = () => {
            $scope.$emit('loadMore', this.currentPagination.pageNumber + 1);
        };

        this.getPageArray = () => {
            const resultArray = [];
            const numberOfPages = this.getNumberOfPages();
            const currentPageNumber = this.currentPagination.pageNumber;
            for (let i = currentPageNumber - 2; i <= currentPageNumber + 2; i++) {
                resultArray.push(i > 0 && i <= numberOfPages ? i : 0)
            }
            return resultArray;
        }
    }]
);
